export type Tome = {
  label: string;
  emoji: string;
  title: string;
  subtitle: string;
  accent: 'blue' | 'green' | 'gold';
  cover: string;
  coverAlt: string;
  features: string[];
};

export type Bonus = {
  number: string;
  title: string;
  pages: string;
  description: string;
  cover: string;
  coverAlt: string;
};

/** Los 3 tomos principales del Kit Maestro. */
export const tomes: Tome[] = [
  {
    label: 'TOMO I',
    emoji: '📘',
    title: 'Blindaje Legal 360°',
    subtitle: 'Marco legal, documentos y protocolos de derivación para trabajar con confianza',
    accent: 'blue',
    cover: 'https://cdn.magicpatterns.com/uploads/oE5jFxLc2rreviCtEDD59t/tomo_1.png',
    coverAlt: 'Portada del Tomo I: Blindaje Legal 360°',
    features: [
      'Marco legal argentino: curación vs acompañamiento (diferencia crítica)',
      'Qué es el intrusismo médico y cómo evitarlo legalmente',
      'Consentimiento informado: qué debe incluir, paso a paso',
      '4 documentos editables listos para firmar (Consentimiento, Deslinde, Confidencialidad, Protocolo de Derivación)',
      'Cómo comunicar con pacientes sin que parezca medicina',
      'Protocolo de derivación ética: cuándo y cómo hacerlo',
      'FAQ legal: respuestas a preguntas difíciles',
      '50 páginas de contenido que te protege legalmente',
    ],
  },
  {
    label: 'TOMO II',
    emoji: '📗',
    title: 'Protocolos de Bioshock y Anamnesis Express',
    subtitle: 'Las 7 preguntas mágicas y el mapa emocional para identificar conflictos biológicos',
    accent: 'green',
    cover: 'https://cdn.magicpatterns.com/uploads/t6h4wEDRCo3RGfGDQxVwbu/Screenshot_20260908-205643~2.jpg',
    coverAlt: 'Portada del Tomo II: Protocolos de Bioshock y Anamnesis Express',
    features: [
      'Fundamentos del Bioshock: entiende cómo funciona el conflicto biológico',
      'Sistema nervioso autónomo: lo que necesitás saber en 10 minutos',
      'Las 7 preguntas mágicas que revelan la raíz del síntoma',
      'Mapa emocional del cuerpo: qué síntoma corresponde a qué conflicto',
      'Árbol genealógico flash: identifica patrones transgeneracionales en 5 minutos',
      'Patrón transgeneracional: cómo opera en tu paciente',
      'Scripts de sesión: qué decir exactamente en cada momento',
      'Casos de estudio reales: protocolo paso a paso',
      '50 páginas de protocolos tácticos, sin teoría innecesaria',
    ],
  },
  {
    label: 'TOMO III',
    emoji: '📕',
    title: 'Actos Psicomágicos y Rituales de Integración',
    subtitle: '15 rituales listos para prescribir que anclan la sanación en el cuerpo',
    accent: 'gold',
    cover: 'https://cdn.magicpatterns.com/uploads/cATMsnKzgCLq5KMaYi6CB8/Screenshot_20260908-205730~2.jpg',
    coverAlt: 'Portada del Tomo III: Actos Psicomágicos y Rituales de Integración',
    features: [
      'Fundamentos de actos psicomágicos: la ciencia detrás de los rituales',
      'Poder del símbolo: cómo los rituales reprograman el inconsciente',
      '15 rituales exactos: Quema del Papel, Baño de Sal, Carta No Enviada, Perdón Simbólico, Visualización Curadora, Movimiento Liberador, Grito Primal, Ceremonia de Cierre, Nudo y Cuerda, Piedra del Peso, Espejo y Mirada, Caja de Recuerdos, Amuleto Personal, Respiración Sagrada, Promesa a Uno Mismo',
      'Cómo prescribir rituales: explicación exacta para cada paciente',
      'Meditaciones diarias y afirmaciones por sistema',
      'Ejercicios de enraizamiento y autocompasión',
      'Señales de integración: cuándo el ritual funcionó',
      '50 páginas de rituales listos para usar mañana',
    ],
  },
];

/** Los 5 bonus estratégicos, siempre incluidos. */
export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'El Cuaderno del Paciente',
    pages: '25 páginas',
    description:
      'Herramienta para que tu paciente llegue a la sesión con su historia, sus síntomas y sus emociones ya ordenados',
    cover: 'https://cdn.magicpatterns.com/uploads/5finiQZ4aqkPnvg1Kw64F5/1.png',
    coverAlt: 'Portada del Bonus 01: El Cuaderno del Paciente',
  },
  {
    number: '02',
    title: 'Bitácora de 21 Días de Vagotonía',
    pages: '25 páginas',
    description:
      'Guía post-sesión para que el paciente entienda sus cambios físicos y no te llame asustado a medianoche',
    cover: 'https://cdn.magicpatterns.com/uploads/q6UweopNBgyHAyVsGaT7PZ/ChatGPT_Image_7_sept_2026,_18_01_29.png',
    coverAlt: 'Portada del Bonus 02: Bitácora de 21 Días de Vagotonía',
  },
  {
    number: '03',
    title: 'Radar de Preguntas Gatillo™',
    pages: '20 páginas',
    description:
      '50 preguntas organizadas por sistemas para profundizar la exploración emocional sin quedarte en blanco',
    cover: 'https://cdn.magicpatterns.com/uploads/tBkt9j9YAkJNCJNn4Vb4f3/1.png',
    coverAlt: 'Portada del Bonus 03: Radar de Preguntas Gatillo',
  },
  {
    number: '04',
    title: 'Guía de Comunicación Ética Meta Ads',
    pages: '15 páginas',
    description:
      'Cómo vender tus servicios en Facebook/Instagram sin violar políticas ni perder cuenta publicitaria',
    cover: 'https://cdn.magicpatterns.com/uploads/q34MrRM3qQUZe6QLCwFoRE/ChatGPT_Image_8_sept_2026,_11_13_55.png',
    coverAlt: 'Portada del Bonus 04: Guía de Comunicación Ética Meta Ads',
  },
  {
    number: '05',
    title: 'Lista de Chequeo Filtro Rojo',
    pages: '10 páginas',
    description: 'Cuándo un paciente NO es para Biodescodificación: tu mayor seguro de vida profesional',
    cover: 'https://cdn.magicpatterns.com/uploads/pdXLmdsTtqiCj347SWauxt/ChatGPT_Image_8_sept_2026,_11_48_27.png',
    coverAlt: 'Portada del Bonus 05: Lista de Chequeo Filtro Rojo',
  },
];
